import { Route } from "@angular/router";

export const nubeRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./pages/nube/nube.component').then(c => c.NubeComponent),
  }
]